import { render, staticRenderFns } from "./RulesAlarmDropdown.vue?vue&type=template&id=bfc391da&scoped=true"
import script from "./RulesAlarmDropdown.vue?vue&type=script&lang=ts"
export * from "./RulesAlarmDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc391da",
  null
  
)

export default component.exports